import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { Helmet } from 'react-helmet-async';
import { CartTotalsTable } from '../Cart/CartTotalsTable';
import { CartItemListing } from '../Cart/CartItemListing';
import { useCart } from '../../state/cart';
import { ContentCard } from '../ContentCard/ContentCard';
import { Fragment, useEffect } from 'react';
import { useSession } from '../../state/session';
import { useHistory } from 'react-router-dom';
import { Button } from '../Form/Button';
import { Loader } from '../Loader/Loader';
import axios from 'axios';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { AlertMessages, useAlerts } from '../AlertMessages/AlertMessages';

export const PunchoutPage = (): JSX.Element => {
	const { cart, setQuantity } = useCart();
	const { user } = useSession();
	const history = useHistory();
	const { api } = useConfig();
	const { currencyCode } = useConfig();
	const t = useTranslation().generic;
	const alerts = useAlerts();

	useEffect(() => {
		if (!user?.punchout) history.push('/');
	}, [user]);

	if (!user?.punchout || !cart) return <Loader />;

	const submitPunchout = async (e: React.FormEvent<HTMLFormElement>) => {
		const form = e.currentTarget;

		// react does not wait for an async handler, so the browser would send the form while the
		// request was still in flight - and again from form.submit() below
		e.preventDefault();

		try {
			await axios.post(`${api}punchout/store-cart.json`, null, { withCredentials: true });
		} catch (error) {
			// handing the form to the buying system with a cart we never stored is the one thing
			// worse than not submitting it
			alerts.set({ type: 'error', message: t.somethingWentWrong });
			return;
		}

		form.submit();
	};

	return (
		<Main>
			<Helmet>
				<title>Punchout</title>
			</Helmet>
			<ContentCard title="" className="checkout-cart">
				<div className="not-mobile">
					<cart-item-heading>
						<span>Produkt</span>
						<span className="text-center">Antal</span>
						<span className="text-right">Totalt</span>
					</cart-item-heading>
				</div>
				<cart-items>
					<CartItemListing items={cart.items} onSetQuantity={setQuantity} />
				</cart-items>
				<div className="mb-3"></div>
				<CartTotalsTable cart={cart} showLetterFee />
				<div className="checkout-footer">
					<p>
						Ditt konto är inställt på att handla med PunchOut. När du klickar på knappen "Skapa inköpsorder"
						ska du skickas tillbaka till ditt inköpssystem och en inköpsorder ska automatiskt genereras med
						produkterna ovan.
					</p>
					<AlertMessages alerts={alerts} />
					<form
						target={user.punchout.ociTarget}
						action={user.punchout.callbackUrl}
						acceptCharset="UTF-8"
						method="POST"
						onSubmit={submitPunchout}
					>
						<input type="hidden" name="~OkCode" value={user.punchout.ociOkCode} />
						<input type="hidden" name="~target" value={user.punchout.ociTarget} />
						<input type="hidden" name="~CALLER" value={user.punchout.ociCaller} />

						<span>
							{cart.items.map((item, i) => (
								<Fragment key={item.product.id + i}>
									<input
										type="hidden"
										name={`NEW_ITEM-DESCRIPTION[${i + 1}]`}
										value={item.product.name.substring(0, 40)}
									/>
									<input type="hidden" name={`NEW_ITEM-MATGROUP[${i + 1}]`} value="44120000" />
									<input type="hidden" name={`NEW_ITEM-QUANTITY[${i + 1}]`} value={item.quantity} />
									<input type="hidden" name={`NEW_ITEM-UNIT[${i + 1}]`} value={item.product.unit} />
									<input
										type="hidden"
										name={`NEW_ITEM-PRICE[${i + 1}]`}
										value={item.price.currentPrice}
									/>
									<input type="hidden" name={`NEW_ITEM-PRICEUNIT[${i + 1}]`} value="1" />
									<input type="hidden" name={`NEW_ITEM-CURRENCY[${i + 1}]`} value={currencyCode} />
									{(item.product.vendorId === 25 || item.product.vendorId === 17) &&
										item.product.deliveryNotice === '' &&
										item.stock.stocked &&
										item.stock.quantity > 0 && (
											<input type="hidden" name={`NEW_ITEM-LEADTIME[${i + 1}]`} value="2" />
										)}
									{item.product.vendorId != 25 &&
										item.product.vendorId != 17 &&
										item.product.deliveryNotice == '' &&
										item.stock.quantity > 0 && (
											<input type="hidden" name={`NEW_ITEM-LEADTIME[${i + 1}]`} value="3" />
										)}
									<input
										type="hidden"
										name={`NEW_ITEM-VENDORMAT[${i + 1}]`}
										value={item.product.displayId}
									/>
									<input type="hidden" name={`NEW_ITEM-SERVICE[${i + 1}]`} value="0" />
									<input
										type="hidden"
										name={`NEW_ITEM-EXT_PRODUCT_ID[${i + 1}]`}
										value={item.product.id}
									/>
									{!!item.product.image && (
										<span>
											<input
												type="hidden"
												name={`NEW_ITEM-ATTACHMENT[${i + 1}]`}
												value={item.product.image}
											/>
											<input
												type="hidden"
												name={`NEW_ITEM-ATTACHMENT_TITLE[${i + 1}]`}
												value="Producktbild"
											/>
										</span>
									)}
									<input type="hidden" name={`NEW_ITEM-EXT_SCHEMA_TYPE[${i + 1}]`} value="UNSPSC" />
								</Fragment>
							))}
						</span>

						<Button type="submit" style={{ padding: '10px', width: '100%' }}>
							Skapa inköpsorder
						</Button>
					</form>
				</div>
			</ContentCard>
		</Main>
	);
};

export const punchoutRouting: Routing = {
	path(urls) {
		return urls.punchoutCart;
	},
	component: PunchoutPage,
	requiresAuth: true,
};
